<template>
    <div :class="`separator--${steez} text-${align}`">
        <span v-if="steez === 'tiny'" class="hr-custom tiny"> </span>
        <span
            v-if="steez === 'fancy'"
            class="hr-custom"
            :style="`border-color:${color || colors.graphite}`"
        >
        </span>
        <fa
            v-if="steez === 'fancy'"
            :icon="['fas', 'star']"
            class="fa-sm inline-color"
            :color="`${color || colors.secondary}`"
        />
        <span
            v-if="steez === 'fancy'"
            class="hr-custom"
            :style="`border-color:${color || colors.graphite}`"
        >
        </span>
        <hr 
            v-if="steez === 'solid'" 
            class="hr-custom solid" 
            :style="`border-color:${color || ''}`"
        />
    </div>
</template>
<script>
import colorUtilities from '~/mixins/colorUtilities'
export default {
    name: 'Separator',
    components: {},
    mixins: [colorUtilities],
    props: {
        steez: {
            type: String,
            default: 'fancy'
        },
        align: {
            type: String,
            default: 'center'
        },
        color: {
            type: String,
            default: ''
        }
    }
}
</script>
